import BaseModel from "../core/BaseModel";
export default class ListViolationModel extends BaseModel {
  constructor() {
    super(
      {
        name: "list_violation",
        tableName: "sra_evaluate",
        label: "Danh Sách Vi Phạm An Toàn",
        display_key: "name",
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          class: "xs-col",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Number",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        name: {
          name: "name",
          type: "String",
          label: "Tên vi phạm an toàn",
          class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        ordinal: {
          name: "ordinal",
          type: "Number",
          label: "Thứ tự",
          class: "center",
        },
        active: {
          name: "active",
          type: "Boolean",
          label: "Hiển thị",
          class: "center",
        },
      }
    );
  }
}
